const indexItems = [
  { title: '动作大片', icon: 'ri-sword-line', count: '2,380 部', desc: '肾上腺素飙升的视觉盛宴' },
  { title: '喜剧剧场', icon: 'ri-emotion-happy-line', count: '1,920 部', desc: '欢乐不停笑声不断' },
  { title: '科幻世界', icon: 'ri-rocket-line', count: '1,560 部', desc: '探索未知宇宙奇观' },
  { title: '悬疑推理', icon: 'ri-search-eye-line', count: '1,340 部', desc: '烧脑反转扣人心弦' },
  { title: '爱情经典', icon: 'ri-heart-line', count: '2,100 部', desc: '感动心灵的浪漫故事' },
  { title: '国产热剧', icon: 'ri-tv-line', count: '3,450 部', desc: '每日更新精彩不断' },
  { title: '日韩剧场', icon: 'ri-earth-line', count: '2,870 部', desc: '亚洲高口碑精选' },
  { title: '动画天地', icon: 'ri-palette-line', count: '4,200 部', desc: '全龄段动画王国' },
  { title: '纪录纪实', icon: 'ri-camera-lens-line', count: '1,860 部', desc: '真实世界的震撼故事' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            分类索引
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            海量片库 · 总有你想看的
          </h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 hover:bg-background-200/70 transition-colors cursor-pointer group text-center"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-200/70 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 text-sm md:text-base mb-1">
                {item.title}
              </h3>
              <p className="text-primary-600 text-xs font-semibold mb-1">
                {item.count}
              </p>
              <p className="text-foreground-500 text-xs hidden sm:block">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}